import { DropdownKeyboard } from './keyboard';
import { NavigationDropdownUI } from './ui';
import { DropdownVisibility } from './visibility';

export { SELECTORS } from './constants';

export class NavigationDropdown {
  constructor() {
    this.ui = new NavigationDropdownUI();
    this.visibility = new DropdownVisibility(this.ui);
    this.keyboard = new DropdownKeyboard(this.ui, this.visibility);
  }

  handleFocusout = ({ relatedTarget }) => {
    if (this.ui.contains(relatedTarget)) {
      return;
    }

    this.visibility.scheduleHide();
  };

  initializeEventListeners = () => {
    const { option, section } = this.ui;

    this.ui.setExpanded(false);

    option.addEventListener('mouseenter', this.visibility.show);
    option.addEventListener('mouseleave', this.visibility.scheduleHide);
    option.addEventListener('focusin', this.visibility.show);
    option.addEventListener('keydown', this.keyboard.handleTriggerKeydown);
    option.addEventListener('focusout', this.handleFocusout);

    section.addEventListener('mouseenter', this.visibility.cancelPendingHide);
    section.addEventListener('mouseleave', this.visibility.scheduleHide);
    section.addEventListener('keydown', this.keyboard.handleLinkKeydown);
    section.addEventListener('focusout', this.handleFocusout);
  };
}
